module.exports = __webpack_public_path__ + "img/si-glyph-lock-white.df0cbe73.svg";